var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipMeritBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "#fff",
    rx: 32.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C6366",
    fillOpacity: 0.5,
    d: "M19.81 26.85s-2.3-.74-1.85.21c.46.95-.65 16.24.29 17.31 1.1 1.26 5.56 3.13 5.56 3.13s7.55 3.41 8.39 3.74c1.89.73 3.02-.16 4.19-.69 1.12-.5 10.81-5.31 11.64-5.72.04-.02.07-.04.1-.08.21-.23 1.07-1.21 1.07-1.95 0-.85-.05-13.8-.54-14.66-.49-.86-14.15-7.37-15.18-7.18-1.02.19-8.2 3.42-8.2 3.42l-5.77 2.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEB94A",
    d: "M19.81 23.32s-1.89-.05-1.43.9c.46.95-.68 16.96.54 17.7 1.22.74 4.9 2.05 4.9 2.05s8.29 3.54 9 4.08c.72.54 2.41-.5 3.58-1.03s11.99-5.62 11.99-5.62.28-.24.28-1.08c0-.85.49-14.85 0-15.71-.49-.86-14.15-7.37-15.18-7.18-1.02.19-8.2 3.42-8.2 3.42l-5.77 2.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE8E3F",
    d: "M33.49 17.43c-.66.12-4.49 1.55-6.7 2.52.03.01-.63.55-.61.56.53.26 7.3 2.77 8.06 2.99.76.22 2.84 1.78 3.73 2 .89.22 2.77 1.33 2.77 1.33s6.05-1.73 7.71-2.43c-1.74-1.35-14-7.16-14.96-6.97Z",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#775220",
    d: "M28.18 29.06c.62.76 4.45 2.31 5.16 1.57.92-.94 4.77-3.02 4.77-3.02s2.68-1.41 3.33-1.63c.65-.22 7.11-1.64 7.11-1.64s-1.76 1.17-2.18 1.29c-.41.12-12.53 5.83-13.28 5.57-.75-.26-4.91-2.14-4.91-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A55E26",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M33.13 30.76s2.57-1.79 3.24-2.17c.67-.39 1.73-.98 1.73-.98s2.81-1.52 3.72-1.74c.91-.22 5.85-1.52 6.55-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE8E3F",
    d: "M33.49 32.81s.11 11.04.12 15.36c.83-.12 1.95-.77 2.8-1.15 1.17-.53 11.99-5.62 11.99-5.62s.28-.24.28-1.08c0-.83.47-14.3.03-15.64-3.01 1.15-11.27 4.92-13.51 6.01-2.61 1.28-1.71 2.12-1.71 2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2E1DD",
    d: "M28.18 19.37c2.02.81 1.45.55 3.07.2 1.62-.35 1.32-1.08 3.99-.2 2.67.88 9.64 4.32 9.64 3.7 0-.62-9.45-5.64-11.4-5.64-1.95 0-5.3 1.94-5.3 1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A55E26",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.104,
    d: "m39.49 28.7-5.04 2.24c-.58.26-1.53.26-2.11 0l-13.6-6.12c-.58-.26-.58-.69 0-.95l13.6-6.12c.58-.26 1.53-.26 2.11 0l13.6 6.12c.58.26.58.69 0 .95l-4.65 2.09M47.58 42.06l-13.16 5.92c-.56.25-1.48.25-2.04 0L19.4 42.17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A55E26",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.104,
    d: "M19.69 42.27c-1.38-.5-1.43-.93-1.43-1.83v-16.1M48.54 24.34v16.1c0 .9-.23 1.4-1.64 1.92M33.4 31.13v17.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A64142",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.104,
    d: "m38.6 43.47 6.28-2.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A55E26",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.104,
    d: "M10.19 34.99h5.23M8.87 31.91h6.55M7.55 28.77h7.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFA0A3",
    d: "M26.79 19.95s-3.33 1.01-2.26 1.31c1.52.43 15.54 7.2 15.54 7.63 0 .43-.75 5.63 0 5.85.75.22 1.96-1.05 2.5-1.1.53-.05.54-.83.54-1.41s.42-4.85-.29-5.37c-1.61-1.19-13.87-7.08-15.28-7.07-1.41.01-.75.16-.75.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8A8082",
    d: "M38.48 27.19c.22-.19 2.62-1.08 2.62-1.08l1.72.74.2.48-2.98 1.08-.07-.27-.96-.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.73 21.04s.72.2 1.45-.18c.82-.42 1.96-.3 3.01.1 1.06.4 11.87 5.88 13.07 6.07 1.21.18.14-.47-.08-.57-.22-.1-13.87-6.83-14.63-6.67-.76.16-2.27.74-2.27.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2B8BA",
    d: "M24.49 20.96c.2.07.47.14 1.7.55 1.24.41 9.68 4.47 9.94 4.61.26.14 3.1 1.45 3.62 1.84.52.39.51.52.33.46s-12.16-5.55-12.16-5.55-3.6-1.74-3.43-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6366",
    d: "M40.08 28.89c0 .43-.75 5.63 0 5.85.75.22 2.05-.81 2.5-1.1.66-.44.54-.83.54-1.41s.13-4.04-.08-4.89a1.42 1.42 0 0 0-.08-.31c-1.02.46-2.49 1.21-3.18 1.52.18.14.3.26.3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFA0A3",
    d: "M40.08 28.89c0 .43-.75 5.63 0 5.85.16.05.33.04.5.02-.02-.05-.04-.11-.07-.15-.33-.5.14-5.64-.22-6.03a.785.785 0 0 0-.21-.17c-.11.05-.21.1-.3.14.18.14.3.26.3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#515150",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "m43.12 26.91-5.67-2.82c-.47-.24-9.19-4.38-9.89-4.52l-.39.12c-.36.18-3.18 1.31-2.82 1.49l15.56 7.34v5.55c0 .53.58.86 1.03.58l1.64-1c.34-.21.54-.57.54-.97v-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#514434",
    d: "M34.12 25.47s-.38.49.67 1.06c1.06.57 3.25 1.5 3.57 2.05.51.91.78.5.84 1.39.06.89.24 4.9.7 4.09.46-.81 0-5.55 0-5.55l-5.54-2.76",
    opacity: 0.47
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 17h42.2v34.52H7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipMeritBadge);
export default __webpack_public_path__ + "static/media/ship-merit-badge.fa7848d6a396a33ee4f99f0c4ca26d55.svg";
export { ForwardRef as ReactComponent };